import '../../vendor/splide.min';

import $ from 'cash-dom';

$(function () {
    if ($('.gallery-carousel').length) {
        $('.gallery-carousel').each((i, gallery) => {
            let galleryId = $(gallery).attr('id');

            if (galleryId) {
                new Splide('#' + galleryId).mount();
            }
        });
    }
});